const $axios = require('axios')
import { log } from '@/decorators'
/* eslint-disable */
export default {
  endPoint: [
    `/${process.env.VUE_APP_API_VERSION}/fluxItems/:id/pictures`,
    `/${process.env.VUE_APP_API_VERSION}/pictures/:id`,
  ],
  client: $axios.create({
    withCredentials: true,
    baseURL: process.env.VUE_APP_API_URL,
    timeout: process.env.VUE_APP_API_TIMEOUT
  }),
  @log('PICTURES - API - GET FLUX ITEMS PICTURES', 3)
  async getFluxItemPictures(params) {
    const res = await this.client.get(`${this.endPoint[0].replace(':id', params.fluxItemId)}`, params)
    return res.data
  }
}